import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle
} from "reactstrap";
import MetaTags from "react-meta-tags";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CashbackTable from "./CashbackTable";
import CashbackFilter from "./cashbackFilter/Index";

function Cashback() {
  const { t } = useTranslation();
  const [selectedValues, setSelectedValues] = useState({
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
  const { data, error, loading, count, paginationResult } = useSelector(state => state.casehbackReducer);
  return (
    <React.Fragment>
      <MetaTags>
        <title>Cashback</title>
      </MetaTags>
      <div className="page-content">
        <div className="container-fluid">
          <h2>{t("Cashback")}</h2>
          <Row>
            <Col className="col-12">
              <Card>
                <CardHeader className="d-flex justify-content-between  align-items-center">
                  <CardTitle className="color-primary">{t("Cashback")} ({count}) </CardTitle>
                </CardHeader>
                <CardBody>
                  <CashbackFilter t={t} loading={loading} selectedValues={selectedValues}
                    setSelectedValues={setSelectedValues} />
                  <CashbackTable
                    selectedValues={selectedValues}
                    cashback={{
                      data,
                      error,
                      loading,
                      paginationResult
                    }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
}
export default Cashback;